import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
  getAllFiles,
  getFileUploadStatusCount
} from "store/actions/fileAction";
import Translate from "helpers/Translate";

function Filter({ client, status, setSelectedStatus }) {
  const dispatch = useDispatch();
  return (
    <div
      className="filter"
      onClick={() => {
        setSelectedStatus(status)
        dispatch(getFileUploadStatusCount(client));
        dispatch(
          getAllFiles({
            clients: [client.id],
            status
          })
        );
      }}
    >
      <i className="fas fa-filter mr-10"></i> {Translate({ id: "filter" })}
    </div>
  );
}

Filter.propTypes = {
  client: PropTypes.object,
  status: PropTypes.string,
  setSelectedStatus: PropTypes.func,
};

export default Filter;
